<div class="login-container">
  <div class="login-card">

    <!-- Logo -->
    <div class="logo-section">
      <img src="assets/befret_logo.png" alt="BeFret" class="logo-img">
      <p class="brand-subtitle">Espace Employ&eacute;</p>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage" class="alert alert-error">
      <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
    </div>

    <!-- Form -->
    <form [formGroup]="form" (ngSubmit)="onLogin()">

      <div class="form-group">
        <label class="form-label">Adresse email</label>
        <div class="input-wrapper">
          <i class="fas fa-envelope input-icon"></i>
          <input type="email" formControlName="email" class="form-control"
                 placeholder="prenom.nom&#64;befret.be" autocomplete="email">
        </div>
      </div>

      <div class="form-group">
        <label class="form-label">Mot de passe</label>
        <div class="input-wrapper">
          <i class="fas fa-lock input-icon"></i>
          <input type="password" formControlName="password" class="form-control"
                 placeholder="Votre mot de passe" autocomplete="current-password">
        </div>
      </div>

      <a routerLink="/reset-password" [queryParams]="{ space: 'staff' }" class="forgot-link">Mot de passe oubli&eacute; ?</a>

      <button type="submit" class="btn btn-login" [disabled]="loading || form.invalid">
        <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
        <i class="fas fa-sign-in-alt" *ngIf="!loading"></i>
        {{ loading ? 'Connexion...' : 'Se connecter' }}
      </button>

    </form>

    <!-- Back to site -->
    <a routerLink="/" class="back-link">
      <i class="fas fa-arrow-left"></i> Retour au site
    </a>

  </div>
</div>
